module.exports = __webpack_public_path__ + "static/media/drone.ad9867b3.mp4";